import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Tools } from '../../../models'

import { IMyDrpOptions } from 'mydaterangepicker'
const DateRangePickerOptions: IMyDrpOptions = {
  dateFormat: 'yyyy-mm-dd',
  dayLabels: {su: '日', mo: '一', tu: '二', we: '三', th: '四', fr: '五', sa: '六'},
  monthLabels: { 1: '一月', 2: '二月', 3: '三月', 4: '四月', 5: '五月', 6: '六月', 7: '七月', 8: '八月', 9: '九月', 10: '十月', 11: '十一月', 12: '十二月' },
  selectBeginDateTxt: '选择开始日',
  selectEndDateTxt: '选择终止日',
  markCurrentDay: true,
  markCurrentMonth: true,
  markCurrentYear: true
}

@Component({
  selector: 'app-date-range-com',
  templateUrl: './date-range.com.html'
})

export class DateRangeComponent implements OnInit {

  @Input() startDate = null
  @Input() endDate = null
  @Output() event = new EventEmitter<any>()
  form: FormGroup
  data = {
    options: DateRangePickerOptions
  }
  tools = new Tools()

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.buildForm()
    this.emitDateRange()
  }

  public submitDateRange() {
    const dr = this.form.value.dateRange
    if (dr) {
      this.emitDateRange()
    } else {
      this.event.emit({
        source: 'date-range',
        data: null
      })
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      dateRange: ''
    })
    const d = new Date()
    const sd = this.startDate ? this.startDate : new Date(d.getFullYear(), d.getMonth(), 1)
    const ed = this.endDate ? this.endDate : this.tools.beijingYearMonthDate()
    this.form.setValue({
      dateRange: {
        beginDate: { year: sd.getFullYear(), month: sd.getMonth() + 1, day: sd.getDate() },
        endDate: ed
      }
    })
  }

  private dateRangeFormData() {
    const dr = this.form.value.dateRange
    return {
      startDate: `${dr.beginDate.year}-${this.padZero(dr.beginDate.month)}-${this.padZero(dr.beginDate.day)}`,
      endDate: `${dr.endDate.year}-${this.padZero(dr.endDate.month)}-${this.padZero(dr.endDate.day)}`
    }
  }

  private emitDateRange() {
    this.event.emit({
      source: 'date-range',
      data: this.dateRangeFormData()
    })
  }

  private padZero(n: number): string {
    return n <= 9 ? `0${n}` : `${n}`
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/date-range/date-range.com.ts